
<template>
  <div class="container page">
    <h1 class="title [ text-center ] [ py-3 ]">
      INFO
    </h1>

    <p class="text-center [ px-3 pb-5 ]">
      Per maggiori informazioni contattare <a class="text-primary text-weight-600" href="mailto:info.cultura@comune.parma.it">info.cultura@comune.parma.it</a>
    </p>

    <p class="text-center [ px-3 pb-5 ]">
      Esclusivamente per problemi tecnici contattare  <a class="text-primary text-weight-600" href="mailto:info.innovazione@comune.parma.it">info.innovazione@comune.parma.it</a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'ViewInfo'
}
</script>
